import { Send01Icon } from '@langchain/untitled-ui-icons';
import { Button, CircularProgress, Textarea } from '@mui/joy';

import { FC } from 'react';

import { Tooltip } from '@/design-system';

type TProps = {
  metaprompt: string;
  setMetaprompt: (value: string) => void;
  isMutating: boolean;
  onSubmit: () => void;
  placeholder?: string;
  autoFocus?: boolean;
};

const InputBar: FC<TProps> = ({
  metaprompt,
  setMetaprompt,
  isMutating,
  onSubmit,
  placeholder,
  autoFocus = false,
}) => {
  const trimmedMetaprompt = metaprompt.trim();
  const disabled = !trimmedMetaprompt || isMutating;

  const renderSendButton = () => {
    if (isMutating) {
      return <CircularProgress size="sm" />;
    }
    return (
      <Tooltip title="Send instruction" side="top">
        <Button
          className="h-[40px] w-[40px]"
          onClick={onSubmit}
          disabled={disabled}
          variant="solid"
          style={{ paddingInline: '0px', borderRadius: '4px' }}
          aria-label="Send instruction"
        >
          <Send01Icon />
        </Button>
      </Tooltip>
    );
  };

  return (
    <div className="flex flex-row">
      <Textarea
        placeholder={placeholder ?? 'Enter instructions'}
        sx={{
          width: '100%',
          resize: 'none',
        }}
        minRows={1}
        maxRows={10}
        autoFocus={autoFocus}
        value={metaprompt}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey && !disabled) {
            e.preventDefault();
            onSubmit();
          }
        }}
        onChange={(e) => setMetaprompt(e.target.value)}
        variant="outlined"
        disabled={isMutating}
      />
      <div className="flex items-center justify-end pl-2">
        {renderSendButton()}
      </div>
    </div>
  );
};

export default InputBar;
